import { render, staticRenderFns } from "./DesignSettings.vue?vue&type=template&id=eba2ad86&"
import script from "./DesignSettings.vue?vue&type=script&lang=js&"
export * from "./DesignSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports